<template>
  <div class="loadingDiv">
    <van-loading size="24px" vertical type="spinner">正在确认支付结果，请稍候...</van-loading>
  </div>
</template>

<script>
import {
  findOrderV2
} from '@/api/api.js'
import {
  Dialog,
  Toast
} from 'vant'

export default {
  name: 'PayLoading', // 推荐添加 name
  data () {
    return {
      index: 0,
      pollTimer: null // 用于存储 setTimeout 的 ID
    }
  },
  methods: {
    async setTimeFn (orderCode) {
      const that = this
      const POLL_INTERVAL = 3000 // 设置轮询间隔 (毫秒)

      if (that.index < 6) {
        try {
          const response = await findOrderV2({
            orderCode: orderCode
          })
          const resss = response.data // 明确获取 data

          // 更严谨地检查 API 响应
          if (resss && resss.result === 'SUCCESS') {
            Dialog.alert({
              title: '提示',
              message: '支付成功',
              confirmButtonText: '返回'
            }).then(() => {
              if (resss.iccid) {
                this.$router.push({
                  name: 'MobileRecharge',
                  params: {
                    iccid: resss.iccid
                  }
                })
              } else if ((resss?.moduleType === '7') || (resss?.moduleType === '6')) {
                this.$router.push({
                  name: 'Home'
                })
              } else {
                this.$router.push({
                  name: 'QueryRecharge'
                })
              }
            })
          } else {
            if (resss.states === 'CLOSED') {
              return Dialog.alert({
                title: '提示',
                message: '订单已关闭',
                confirmButtonText: '返回'
              }).then(() => {
                this.$router.push({
                  name: 'QueryRecharge'
                })
              })
            }
            if (resss.states === 'PAYERROR') {
              return Dialog.alert({
                title: '提示',
                message: '支付失败',
                confirmButtonText: '返回'
              }).then(() => {
                this.$router.push({
                  name: 'QueryRecharge'
                })
              })
            }
            // 准备下一次轮询
            that.index++
            // 使用 setTimeout 添加延迟，避免连续请求
            that.pollTimer = setTimeout(() => {
              that.setTimeFn(orderCode)
            }, POLL_INTERVAL)
          }
        } catch (error) {
          Toast.fail('查询支付状态失败，请稍后重试') // 提供用户反馈
          // 可以选择在此处增加 index 以计入尝试次数，或按需处理
          that.index++
          // 即使出错也继续轮询（或者根据策略停止）
          if (that.index < 6) {
            that.pollTimer = setTimeout(() => {
              that.setTimeFn(orderCode)
            }, POLL_INTERVAL)
          } else {
            this.handleTimeout(orderCode)
          }
        }
      } else {
        this.handleTimeout(orderCode)
      }
    },
    handleTimeout (orderCode) {
      const that = this
      Toast.clear()
      return Dialog.confirm({
        title: '支付未完成',
        message: '未查询到支付成功记录',
        confirmButtonText: '重新检查',
        cancelButtonText: '返回'
      }).then(() => {
        that.index = 0
        that.setTimeFn(orderCode)
      }).catch(() => {
        this.$router.push({
          name: 'QueryRecharge'
        })
      })
    }
  },
  created () {
    const orderCode = this.$route.params.orderCode

    // 检查 orderCode 是否存在
    if (!orderCode) {
      Toast.fail('缺少订单号')
      console.error('PayLoading: 缺少 orderCode 参数')
      // 可以选择跳转到错误页面或主页
      this.$router.push({
        name: 'QueryRecharge'
      })
      return
    }

    // 启动轮询
    this.setTimeFn(orderCode)
  },
  beforeDestroy () { // Vue 2, Vue 3 使用 unmounted()
    // 清理定时器，防止内存泄漏
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
    }
  }
}
</script>

<style scoped lang='less'>
  .loadingDiv {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -70%);
  }
</style>
